import { IGetIncorporacaoBlocoDropDownUseCase } from "../../../presentation/useCases/read/get_incorporacao_bloco_drop_down_use_case";
import { IncorporacaoBlocoDropDown } from "../../models/incorporacao_bloco_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetIncorporacaoBlocoDropDownUseCase
 */

export class GetIncorporacaoBlocoDropDownUseCase implements IGetIncorporacaoBlocoDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getIncorporacaoBlocoDropdown(
    idEmpreendimento: number,
  ): Promise<IncorporacaoBlocoDropDown[]> {
    return await this.repository.getIncorporacaoBlocoDropdown(idEmpreendimento);
  }
}
